/**
* @name: header-logo-sca
* @author: weiyong
* @date: 2023-05-12 17:58
* @description：header-logo-sca
* @update: 2023-05-12 17:58
*/
<template>
  <li :class="prefixCls" class="branding-container"  @click="goHome">
    <div class="branding">
      <div class="logo-container">
        <img :src="logoUrlObj||'/static/img/companyLogo.svg'" class="company-logo">
      </div>
      <div v-show="openFlag" class="text-dian-dian company-name"> {{ systemName || 'SCANTIST' }}</div>
    </div>
  </li>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "header-logo-sca",
});
</script>

<script lang="ts" setup>
import {useDesign} from "@/hooks/web/useDesign";
import {useAccountInfo} from "@/components/Application/hooks/useAccountInfo";
import {PageEnum} from "@/enums/pageEnum";
import {useGo} from "@/hooks/web/usePage";
import {useUserStore} from "@/store/modules/user";

const {prefixCls} = useDesign('header-logo-sca');

interface IProps{
  openFlag:boolean
}
const props=withDefaults(defineProps<IProps>(),{
  openFlag:false
})

const { systemName, logoUrlObj } = useAccountInfo();

const go = useGo();
const userStore = useUserStore();
function goHome() {
  go(userStore.getUserInfo.homePath || PageEnum.BASE_HOME);
}
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-header-logo-sca';

.@{prefix-cls} {
  &.branding-container {
    --el-custom-sidebar-base-level-padding: 20px;
    padding-top: 24px;
    height: 47px;
    margin-bottom: 24px;

    .branding {
      display: flex;
      flex-direction: row;
      gap: 8px;
    }

    .company-name {
      color: var(--el-color-white);
      height: 38px;
      line-height: 38px;
      font-family: GoodTimes;
      flex:1;
      overflow: hidden;
    }

    .logo-container {
      background-color: var(--el-color-white);
      border-radius: 19px;
      padding: 4px;
      margin-left: calc(var(--el-custom-sidebar-base-level-padding));
    }

    .company-logo {
      width: 30px;
      height: 30px;
      display: block;
      border-radius: 30px;
      margin-left: auto;
      margin-right: auto;
    }

    img {
      min-width: 30px;
    }


  }
}
</style>
